module.exports = __webpack_public_path__ + "img/starling_logo_small.f75166e6.png";